import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import TableSearch from "./TableSearch.js";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Select2 from "../../Select2/select2.js";


function ProjectBudget() {
	// Initialize directly from localStorage so it's not null on first render
  const initialUser = (() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  })();

  const [userData, setUserData] = useState(initialUser);
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (authToken) {
      // Keep state in sync if user data changes
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        try {
          setUserData(JSON.parse(storedUser));
        } catch (err) {
          console.error("Failed to parse stored user:", err);
          localStorage.removeItem("user");
          navigate("/"); // redirect if corrupted
        }
      }
    } else {
      // No token → clear session and redirect
      localStorage.removeItem("user");
      navigate("/"); // adjust path to your login route
    }
  }, [navigate]);


    
     const userid  = JSON.parse(localStorage.getItem("userId"))
	const [formData, setFormData] = useState({
		n_org_id: "",
		n_participant_id: "",
		c_initiative_name: "",
		c_project_objective: "",
		c_group: "",
		n_project_classification: "",
		c_project_description: "0",
		n_project_num :'',
		n_individual :'',
		n_current_implementation_status :'',
		n_budget :''
	  });
	  
	
	 const [errors, setErrors] = useState({});
	 const [organization, setOrganizationList] = useState([]);
     const [participants, setParticipantsList] = useState([]);	
	 const [classificationstatus, setProjectClassificationList] = useState([]);
	  const [implementationstatus, setCurrentImplemenationStatusList] = useState([]);
	 const [selectedUser, setSelectedUser] = useState(null);
	 const [yesno, setYesNoList] = useState([]);
	 const [internes, setRaporteeList] = useState([]);
	 const [columns, setColumns] = useState([]);
	 const [tabledata, settableData] = useState([]);	
	 const [selectedparticipant, setSelectedParticipant] = useState([]);
     const [editMode, setEditMode] = useState(false);
     const [modalData, setModalData] = useState(false);
     const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
     const [indiid, setModalId] = useState(null);	
     const [raporteedata, setRapporteeData] = useState({
	  n_stakeholder_id : ""
      });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {
       console.log("userdata",userData)
     axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_organization_mst'),cols:strEncode('*'),whrc : userData.usertype == 1 ? "" :  strEncode('id = "'+userData.org+'"') },{ headers: { 'Content-Type': 'application/json' } }) 
	   .then( (res) => {
	   setOrganizationList(res.data);
	   }).catch( (error) => { console.log(error); });

	 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_registration'),cols:strEncode('*'),whrc : userData.usertype === 1 ? "" : strEncode('n_org_id = "'+userData.org+'"') },{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setParticipantsList(res.data);
	    }).catch( (error) => { console.log(error); }); 
	

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_yes_no_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setYesNoList(res.data);
	  }).catch( (error) => { console.log(error); });

	    axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_current_implementation_status_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setCurrentImplemenationStatusList(res.data);
	  }).catch( (error) => { console.log(error); });

	   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_project_classification_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setProjectClassificationList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_project_budget'),cols:strEncode('*'),whrc :  userData?.usertype > 0 ? "":  strEncode('n_user_id = "'+userid+'"')},{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "Actions",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   </div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
	    n_org_id: "",
		n_participant_id: "",
		c_initiative_name: "",
		c_project_objective: "",
		c_group: "",
		n_project_classification: "",
		c_project_description: "",
		n_project_num :'',
		n_individual :'',
		n_current_implementation_status :'',
		n_budget :''
	  });
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }


  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_project_budget'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 setFormData({
		id : response.data[0].id,
	    n_org_id: response.data[0].n_org_id,
		n_participant_id: response.data[0].n_participant_id,
		c_initiative_name: response.data[0].c_initiative_name,
		c_project_objective: response.data[0].c_project_objective,
		c_group: response.data[0].c_group,
		n_project_classification: response.data[0].n_project_classification,
		c_project_description: response.data[0].c_project_description,
		n_project_num :response.data[0].n_project_num,
		n_individual :response.data[0].n_individual,
		n_current_implementation_status :response.data[0].n_current_implementation_status,
		n_budget :response.data[0].n_budget
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  
   // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	
	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	
	  const handlevalidateNumber = (e) => {
  const { name, value } = e.target;
  let numericValue = Number(value);

  // Clamp value between 0 and 10
  if (numericValue < 0) numericValue = 0;

  setFormData((prev) => ({
    ...prev,
    [name]: numericValue,
  }));
};

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};

	 
	  const handleChangeparticipants = (e) => {
		console.log("we are here")
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value, // Keep existing password if blank
		}));

         axios.post(`${API_BASE_URL}/api/custom/selectall`,
			 { t: strEncode('v_pmis_participants_registration_display'),cols:strEncode('*'),whrc:strEncode('id = "'+e.target.value+'"') },
			 { headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					var data  = res.data
					setSelectedParticipant(data);
					}).catch(error => {
					console.error("API Error:", error);
				  });
	};
	
	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		  const payload = {
				data: {
					...formData,
					n_user_id: userData?.id					
				}
				};
		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/budget/create`, payload);
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/budget/update`, { data: formData });
			alert("تم تحديث البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
			n_org_id: "",
		n_participant_id: "",
		c_initiative_name: "",
		c_project_objective: "",
		c_group: "",
		n_project_classification: "",
		c_project_description: "",
		n_project_num :'',
		n_individual :'',
		n_current_implementation_status :'',
		n_budget :''
		  });
	  
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };
 

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">إدارة المستخدمين</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
			 <span className="d-sm-block d-none">قائمة</span>
           
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}>
            <span className="d-sm-block d-none">إضافة تقييم المشارك</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<TableSearch
									title="بيانات المستخدم"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
                                <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">منظمة</label>
									<div className="col-md-9">
									<select name="n_org_id" className="form-select" onChange={handleChange} value={formData.n_org_id}>
										<option value="">تحديد نوع المستخدم</option>
										{organization.map((option) => (
										<option value={option.id} key={option.id}>{option.c_org_name}</option>
										))}
									</select>
									{errors.n_org_id && <span style={{ color: "red" }}>{errors.n_org_id}</span>}
									</div>
								</div>


									<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حدد المشارك</label>
									<div className="col-md-9">
										 <Select2 name="n_participant_id"  value={String(formData.n_participant_id || '')} 
										  onChange={handleChangeparticipants.bind(this)} style={{ width: "100%" }}>
											<option value=''> -- Select -- </option>
											{participants.map(option => {
											return <option value={String(option.id)} key={option.id} >{option.c_name}</option>
											})}
										 </Select2>								
											{errors.n_participant_id && <span style={{ color: "red" }}>{errors.n_participant_id}</span>}
									</div>
								</div>

								<div>
									{selectedparticipant.map((option) => (
										<table style={{background:"#cecece",borderRadius:"5px"}} className="table table-responsive table-bordered table-striped">
											<tr><td>اسم</td><td>{option.c_name}</td></tr>
											<tr><td>هاتف</td><td>{option.n_phone_no}</td></tr>
											<tr><td>جنس</td><td>{option.n_gender}</td></tr>
										</table>
										))}
								</div>
 
                                  <div className="row mb-15px" key="c_initiative_name">
									<label className="form-label col-form-label col-md-3">اسم المبادرة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_initiative_name"
										value={formData.c_initiative_name}
										onChange={handleChange}
										/>
                                     {errors.c_initiative_name && <span style={{ color: "red" }}>{errors.c_initiative_name}</span>}
									</div>
									</div>

                                    <div className="row mb-15px" key="c_project_objective">
									<label className="form-label col-form-label col-md-3">هدف المشروع</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_project_objective"
										value={formData.c_project_objective}
										onChange={handleChange}
										/>
                                     {errors.c_project_objective && <span style={{ color: "red" }}>{errors.c_project_objective}</span>}
									</div>
									</div>



                                <div className="row mb-15px" key="c_group">
									<label className="form-label col-form-label col-md-3">المنطقة أو الفئة المستهدفة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_group"
										value={formData.c_group}
										onChange={handleChange}
										/>
                                     {errors.c_group && <span style={{ color: "red" }}>{errors.c_group}</span>}
									</div>
									</div>

									<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">تصنيف المشروع أو المبادرة</label>
									<div className="col-md-9">
									<select name="n_project_classification" className="form-select" onChange={handleChange} value={formData.n_project_classification}>
										<option value="">يختار</option>
										{classificationstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_project_classification && <span style={{ color: "red" }}>{errors.n_project_classification}</span>}
									</div>
								</div>


								 <div className="row mb-15px" key="c_project_description">
									<label className="form-label col-form-label col-md-3">شرح توضيحي مختصر عن المشروع أو المبادرة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_project_description"
										value={formData.c_project_description}
										onChange={handleChange}
										/>
                                     {errors.c_project_description && <span style={{ color: "red" }}>{errors.c_project_description}</span>}
									</div>
									</div>


									<div className="row mb-15px" key="n_project_num">
									<label className="form-label col-form-label col-md-3">رقم المشروع</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "n_project_num"
										value={formData.n_project_num}
										onChange={handleChange}
										/>
                                     {errors.n_project_num && <span style={{ color: "red" }}>{errors.n_project_num}</span>}
									</div>
									</div>

                                 


								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">فردي</label>
									<div className="col-md-9">
									<select name="n_individual" className="form-select" onChange={handleChange} value={formData.n_individual}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_individual && <span style={{ color: "red" }}>{errors.n_individual}</span>}
									</div>
								</div>
 <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حالة التنفيذ الحالية (منجز / قيد التنفيذ / غير منجز)
</label>
									<div className="col-md-9">
									<select name="n_current_implementation_status" className="form-select" onChange={handleChange} value={formData.n_current_implementation_status}>
										<option value="">يختار</option>
										{implementationstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_current_implementation_status && <span style={{ color: "red" }}>{errors.n_current_implementation_status}</span>}
									</div>
								</div>
															
									<div className="row mb-15px" key="n_budget">
									<label className="form-label col-form-label col-md-3">المبلغ المخصص للمشروع</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_budget"
										value={formData.n_budget}
										onChange={handlevalidateNumber}
										
										/>
                                     {errors.n_budget && <span style={{ color: "red" }}>{errors.n_budget}</span>}
									</div>
									</div>                       

                                {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">يحفظ</button>
								:
								<button type="submit" className="btn btn-success w-100px">تحديث</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
		
		</div>
	)
}

export default ProjectBudget;